import type { SalesforceAccountTask } from '../../../../domain/salesforceActivity';

export const isSalesforceAccountTask = (v: unknown): v is SalesforceAccountTask =>
  !!(v && typeof v === 'object' && 'whatId' in v);
